module.exports = __webpack_public_path__ + "static/media/404.6dcf5c8e.jpg";